<template>
  <div class="sidebar bg-dark">
    <div class="sidebar-content">
      <div class="p-4 text-muted">{{ $t('Menu') }}</div>
      <router-link
        class="d-block bg-dark px-4 py-3 text-muted sidebar-link"
        :to="ROUTE_DASHBOARD"
        @click.native="onLinkClick"
      >
        <FontAwesomeIcon class='text-primary mr-2' icon="music"/>
        {{ $t('Now Playing') }}
      </router-link>
      <router-link
        class="d-block bg-dark px-4 py-3 text-muted sidebar-link"
        to="/playlists"
        @click.native="onLinkClick"
      >
        <FontAwesomeIcon class='text-primary mr-2' :icon="['far', 'list-alt']"/>
        {{ $t('Playlists') }}
      </router-link>
      <router-link
        class="d-block bg-dark px-4 py-3 text-muted sidebar-link"
        to="/playlist-schedule"
        @click.native="onLinkClick"
      >
        <FontAwesomeIcon class='text-primary mr-2' :icon="['far', 'clock']"/>
        {{ $t('Playlist Schedule') }}
      </router-link>
      <router-link
        class="d-block bg-dark px-4 py-3 text-muted sidebar-link"
        :to="ROUTE_JINGLES"
        @click.native="onLinkClick"
      >
        <FontAwesomeIcon class='text-primary mr-2' :icon="['fas', 'bullhorn']"/>
        {{ $t('Jingles') }}
      </router-link>
      <router-link
        class="d-block bg-dark px-4 py-3 text-muted sidebar-link"
        :to="ROUTE_JINGLE_SCHEDULE"
        @click.native="onLinkClick"
      >
        <FontAwesomeIcon class='text-primary mr-2' :icon="['far', 'calendar-alt']"/>
        {{ $t('Jingle Schedule') }}
      </router-link>
      <router-link
        class="d-block bg-dark px-4 py-3 text-muted sidebar-link"
        :to="ROUTE_JUKEBOX"
        @click.native="onLinkClick"
      >
        <FontAwesomeIcon class='text-primary mr-2' :icon="['fas', 'bullseye']"/>
        {{ $t('Jukebox') }}
      </router-link>
      <router-link
        class="d-block bg-dark px-4 py-3 text-muted sidebar-link"
        :to="ROUTE_REPORTS"
        @click.native="onLinkClick"
      >
        <FontAwesomeIcon class='text-primary mr-2' :icon="['fas', 'chart-bar']"/>
        {{ $t('Reports') }}
      </router-link>
      <router-link
        class="d-block bg-dark px-4 py-3 text-muted sidebar-link"
        to="/help"
        @click.native="onLinkClick"
      >
        <FontAwesomeIcon class='text-primary mr-2' :icon="['far', 'question-circle']"/>
        {{ $t('Help') }}
      </router-link>
      <a
        class="d-block bg-dark px-4 py-3 text-muted sidebar-link"
        href="#"
        @click.prevent="logout"
      >
        <FontAwesomeIcon class='text-primary mr-2' :icon="['fas', 'sign-out-alt']"/>
        {{ $t('Sign Out') }}
      </a>
    </div>
  </div>
</template>

<script>
import { ROUTE_DASHBOARD, ROUTE_LOGIN, ROUTE_JINGLES, ROUTE_JINGLE_SCHEDULE, ROUTE_JUKEBOX, ROUTE_REPORTS } from '@/const/routeNames'
import localStorageUtil from '@/utils/localStorageUtil'
import audioManager from '@/utils/audioManager'

export default {
  name: 'Sidebar',

  data () {
    return {
      ROUTE_DASHBOARD,
      ROUTE_JINGLES,
      ROUTE_JINGLE_SCHEDULE,
      ROUTE_JUKEBOX,
      ROUTE_REPORTS
    }
  },

  computed: {
    userProvider () {
      return this.$store.state.auth.userProvider
    }
  },

  methods: {
    onLinkClick () {
      // Na desktopu ne zatvaramo sidebar nakon klika
    },

    logout () {
      localStorageUtil.removeToken()
      localStorageUtil.removeUserEmail()
      localStorageUtil.removeUserProvider()
      localStorageUtil.removeSubscribeLink()
      audioManager.pause()
      this.$store.commit('setAuthorized', false)
      this.$store.commit('setUserEmail', null)
      this.$store.commit('setUserProvider', null)
      this.$store.commit('setSidebarOpen', false)
      this.$router.push(ROUTE_LOGIN)
    }
  }
}
</script>

<style scoped>
.sidebar {
  width: 280px;
  height: calc(100vh - 48px);
  position: fixed;
  left: 0;
  top: 48px;
  overflow-y: auto;
  z-index: 999;
  border-right: 1px solid #24262B;
}

.sidebar-link {
  transition: background-color 0.2s ease;
  text-decoration: none;
}

.sidebar-link:hover {
  background-color: #24262B !important;
}

.sidebar-link.router-link-active {
  border-left: 3px solid;
  border-left-color: #309FFF;
  background-color: transparent !important;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/Sidebar.vue